import React from "react";
import PropertyDetailsList from "../../JsonData/property-details.json";

const PropertySummary = ({ property }) => {
  if (!property?.propertyType || property.propertyType.length === 0) {
    return null;
  }

  return (
    <div className="container"style={{paddingBottom:"20px",paddingTop:"30px"}}>
      <table className="table table-striped">
        <thead>
          <tr>
            <th scope="col">Property Type</th>
            <th scope="col">Unit</th>
            <th scope="col">Size</th>
          </tr>
        </thead>
        <tbody>
          {property.propertyType.map((detail, index) => (
            <tr key={index}>
              <td>{detail.type}</td>
              <td>{detail.unit}</td>
              <td>{detail.size}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PropertySummary;

